export class Csp5040Class {
    UserNam: string;
    ShowAllFlag: number;
}
